import { gql } from '@apollo/client'

export interface IGetLatestDealVersionResponse {
  latestDeal: {
    dealId: number
    dealVersionNumber: number
    dealNumber: number
    currentVersionFlag: string
    hierarchyCode: string
    businessModelCode: string
    controlCountryCode: string
  }
}

export interface IGetLatestDealVersionRequest {
  dealNumber: number
}

const GET_LATEST_DEAL_VERSION = gql`
  query latestDeal($dealNumber: Int!) {
    latestDeal(dealNumber: $dealNumber) {
      dealId
      dealVersionNumber
      currentVersionFlag
      dealNumber
      hierarchyCode
    }
  }
`

export default GET_LATEST_DEAL_VERSION
